import React, { useEffect, useState } from "react";
import NavBarButton from "../buttons/NavBarButton";
import Space from "../layout/Space";
import { useAuth } from "../auth/FirebaseAuth";

import Icon1 from "../icons/Icon";
import { useLocation } from "react-router-dom";

function ParametersNavBar({
  actualpage,
  override_id = null,
  navigateWorkspace,
  userData,
  orgData,
}) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  const handleFetchData = async () => {};

  useEffect(() => {
    if (userData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [userData]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !userData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  return (
    <div className="flex flex-col w-fit min-w-c200 h-full pointer-events-auto overflow-y-auto  pb-20 pl-5 pr-1 bg-white border-r-1 border-shadow_10">
      <Space y={25} />
      <div className="text-hx font-medium">Paramètres</div>
      <Space y={27} />

      {/* Navigation buttons */}
      <NavBarButton
        icon="user"
        isActualPage={
          location.pathname.includes("/account") ||
          location.pathname.includes("/parameters")
        }
        onClick={() => navigateWorkspace("/account", orgData)}
      >
        Compte
      </NavBarButton>
      {(!orgData.restrictions?.settings_access || userData.org_admin) && (
        <>
          <NavBarButton
            icon="organisation"
            isActualPage={location.pathname.includes("/organisation")}
            onClick={() => navigateWorkspace("/organisation", orgData)}
          >
            Entreprise
          </NavBarButton>

          <NavBarButton
            isActualPage={location.pathname.includes("/tags")}
            icon="tag"
            onClick={() => navigateWorkspace("/tags", orgData)}
          >
            Tags
          </NavBarButton>
        </>
      )}
    </div>
  );
}

export default ParametersNavBar;

export const PremiumBar = () => {
  return (
    <div className="text-h3 flex items-center bg-purple-50 border-l-2 border-violet-500 px-2 py-0.5 rounded-md w-fit flex-row gap-3 text-violet-500 font-medium">
      <Icon1 icon_name="stars" fill="#8b5cf6" size={18}></Icon1> Premium
    </div>
  );
};

export const ForeverBar = () => {
  return (
    <div className="text-h3 flex items-center bg-purple-50 px-2 py-0.5 rounded-full w-fit flex-row gap-3 text-violet-500 font-medium">
      Abonnement à vie
    </div>
  );
};

export const EngagementBar = ({ engagement }) => {
  return (
    <div
      className={` text-neutral-500 bg-neutral-100 text-h3 flex items-center px-2 py-0.5 rounded-lg w-fit flex-row gap-3 font-medium`}
    >
      {engagement === "forever"
        ? "Abonnement à vie"
        : engagement === "year"
        ? "Annuel"
        : "Mensuel"}
    </div>
  );
};

export const BusinessBar = () => {
  return (
    <div className="text-h3 flex items-center bg-sky-50 pr-2  border-l-2 border-blue-500 py-0.5 rounded-md w-fit flex-row gap-3  font-medium text-blue-600">
      <Icon1
        icon_name="hexagone2"
        fill="#2563eb  "
        size={18}
        margin="2px"
      ></Icon1>{" "}
      Business
    </div>
  );
};

export const StarterBar = () => {
  let dict = {
    infos_devis: {
      id: "Q0uDXceZZd2fO5vEUU8a9T",
      name: "Denys Loiret",
      email: "denys@ouestenergiecontrole.fr",
      phone: "06551511511",
      address: "1 RUE RAYMOND CIVET",
      postal: "44119",
      city: "TREILLIERES",
      country: "France",
    },
    infos_master: {
      name: "OUEST ENERGIE CONTROLE",
      email: "rapport@ouestenergiecontrole.fr",
      phone: "06510024621",
      date: "24/02/2025 20:29:03",
      logo: "https://storage.googleapis.com/foundry-2dlu01.appspot.com/logos/wmLGIwRMtQD2LLc6nXQf/OEC_LOGO.png",
    },
    form_name: "Descriptif du projet maison",
    caegories: [
      {
        name: "Catégorie Eau chaude sanitaire ",
        fields: [
          {
            name: "Ballon thermo",
            type: "check",
            value: false,
          },
          {
            name: "Lié au chauffage",
            type: "check",
            value: true,
          },
          {
            name: "Ballon solaire",
            type: "check",
            value: true,
          },
          {
            name: "Autre",
            type: "text",
            value: "truc chelou",
          },
          {
            name: "Modèle de l'équipement:",
            type: "text",
            value:
              "Dyson 3000 fdhdhshfh kjsdhjf hdsh fkhsdk dk dhks hds jhds hdskhsdkhkdkds fdd fd d dddfd",
          },
        ],
      },
      {
        name: "Catégorie Ventilation ",
        fields: [
          {
            name: "Simple flux hygro B",
            type: "check",
            value: true,
          },
          {
            name: "Double flux",
            type: "check",
            value: true,
          },
          {
            name: "Modèle de la vmc:",
            type: "text",
            value: "78DD PT",
          },
          {
            name: "Type de gaines",
            type: "text",
            value: "Souple renforcée",
          },
        ],
      },
    ],
  };
  return (
    <div className="text-h3 flex items-center bg-sky-100 pr-2 py-0.5 rounded-full w-fit flex-row gap-3  font-medium text-blue-600">
      <Icon1
        icon_name="hexagone2"
        fill="#2563eb  "
        size={18}
        margin="2px"
      ></Icon1>{" "}
      Starter
    </div>
  );
};
